import '@main';

const copyBtn = document.querySelector('.j-copy-btn');

copyBtn.addEventListener('click', () => {
  navigator.clipboard.writeText(window.location.href);

  u.notify('複製成功', 'success', {wait: 3});
});
